<template>
  <div :id="`${source}_salesforce_statuses_select`" class="w-full p-4">
    <SearchableMultiSelectDropdown
      v-model="selectedValue"
      :options="availableStatuses"
      :multiple="false"
      placeholder="Select status"
      search-title="Choose Status"
      search-placeholder="Search statuses..."
      empty-state-text="No statuses found"
      :disabled="false"
      @selection-change="handleStatusChange"
    />
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";

import eventBus from "@/src/utils/eventBus.js";
import SearchableMultiSelectDropdown from "@/src/components/SearchableMultiSelectDropdown.vue";

const props = defineProps({
  source: { type: String, required: true, default: "custom_table" },
  row: { type: Object, required: true },
  extraData: { type: Object, required: true },
});

const selectedValue = ref(null);
const availableStatuses = ref(props.extraData || []);

// Initialize selected value
onMounted(() => {
  selectedValue.value = props.row?.crm_status || null;
});

const handleStatusChange = (value) => {
  const updatedRow = {
    ...props.row,
    crm_status: value,
    originalStatus: props.row.crm_status,
  };
  eventBus.emit("crm-statuses-select", updatedRow);
};
</script>
